import * as breakpoints from "../styles/breakpoints";
import * as colors from "../styles/colors";
import * as docketPropTypes from "../docketPropTypes";
import PropTypes from "prop-types";
import React from "react";
import TextField from "./TextField";
import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
	loginTextField: {
		width: "100%",
		color: colors.textGrey,
		height: 40,
		paddingLeft: 15,
		paddingRight: 15,
		borderRadius: 0,
		borderStyle: "solid",
		borderWidth: 1,
		borderColor: colors.docketGrey,
		fontSize: 15,
		display: "block",
		WebkitAppearance: "none",

		":focus": {
			borderColor: colors.docketGrey,
		},

		"::-webkit-input-placeholder": {
			color: colors.textGrey,
			opacity: 1.0,
		},

		"::-moz-placeholder": {
			color: colors.textGrey,
			opacity: 1.0,
		},

		":-ms-input-placeholder": {
			color: colors.textGrey,
			opacity: 1.0,
		},

		[breakpoints.portraitTabletAndDown]: {
			borderColor: colors.docketLightishBlue,
			color: colors.docketLightishBlue,
			backgroundColor: colors.transparent,

			":focus": {
				borderColor: colors.docketLightishBlue,
			},

			"::-webkit-input-placeholder": {
				color: colors.docketLightishBlue,
				opacity: 1.0,
			},

			"::-moz-placeholder": {
				color: colors.docketLightishBlue,
				opacity: 1.0,
			},

			":-ms-input-placeholder": {
				color: colors.docketLightishBlue,
				opacity: 1.0,
			},
		},
	},
	loginTextFieldErrored: {
		borderColor: colors.docketRed,

		":focus": {
			borderColor: colors.docketRed,
		},
	},
});

const BorderedLoginTextField = ({
	aStyles,
	autoFocus,
	errored,
	placeholder,
	onChange,
	type,
	value,
	autoComplete,
}) => {
	return (
		<TextField
			autoFocus={autoFocus}
			aStyles={[
				styles.loginTextField,
				errored ? styles.loginTextFieldErrored : null,
				aStyles,
			]}
			placeholder={placeholder}
			onChange={onChange}
			type={type}
			value={value}
			autoComplete={autoComplete}
		/>
	);
};

BorderedLoginTextField.propTypes = {
	aStyles: docketPropTypes.aphroditeStyles,
	autoFocus: PropTypes.bool,
	errored: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	placeholder: PropTypes.string.isRequired,
	type: PropTypes.string,
	value: PropTypes.string.isRequired,
	autoComplete: PropTypes.string,
};

export default BorderedLoginTextField;
